import { CloseButton, Flex } from '@cmpsr/components';

type MobileNavigationMenuHeaderProps = {
  onClose: () => void;
};

export default function MobileNavigationMenuHeader({ onClose }: MobileNavigationMenuHeaderProps) {
  return (
    <Flex justifyContent="end" alignItems="center" py="spacer-3" height={{ base: '56px', md: '72px' }}>
      <CloseButton color="text-light" onClick={onClose} />
    </Flex>
  );
}
